import { render, staticRenderFns } from "./SupportGuide.vue?vue&type=template&id=5e203e61"
import script from "./SupportGuide.vue?vue&type=script&lang=js"
export * from "./SupportGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports